<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <g clip-path="url(#clip0_1282_40538)">
            <path
                d="M9 0C13.9703 0 18 4.02966 18 9C18 13.9703 13.9702 18 9 18C4.02984 18 0 13.9714 0 9C0 4.02858 4.02912 0 9 0Z"
                fill="#53AE94"
            />
            <path
                d="M10.1107 7.80066V6.46182H13.1723V4.42188H4.83546V6.46182H7.89744V7.79958C5.40894 7.91388 3.53784 8.40672 3.53784 8.99712C3.53784 9.58752 5.40984 10.0804 7.89744 10.1954V14.4839H10.1114V10.195C12.5954 10.0804 14.4628 9.58788 14.4628 8.99802C14.4628 8.40816 12.5954 7.91568 10.1114 7.80102M10.1114 9.83178V9.8307C10.049 9.83466 9.72804 9.85392 9.01344 9.85392C8.44212 9.85392 8.04018 9.83772 7.89852 9.83034V9.83214C5.7 9.73476 4.05894 9.35189 4.05894 8.8938C4.05894 8.4357 5.70018 8.05338 7.89852 7.95582V9.45072C8.04252 9.46062 8.45436 9.48492 9.0228 9.48492C9.70554 9.48492 10.0488 9.45648 10.1118 9.45072V7.95582C12.306 8.05356 13.9433 8.43678 13.9433 8.89326C13.9433 9.34974 12.3053 9.73314 10.1118 9.83088"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_1282_40538">
                <rect width="18" height="18" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
